// extracted by mini-css-extract-plugin
module.exports = {"container":"footer_container__3G8Gg","linkParagraph":"footer_linkParagraph__1HRNO","footer":"footer_footer__32o01"};